<template>
  <div class="gallery-design-entry">
    <button class="gallery-design-link" data-exhibition-control type="button" aria-label="The design" aria-haspopup="dialog" @click="$emit('design')">
      <span><span class="design-entry-prefix">The </span><span class="design-entry-word">design</span></span>
      <svg class="design-entry-book" viewBox="0 0 24 24" aria-hidden="true" data-exhibition-icon><path class="design-cover-back" d="M5 5h14v15H5z"/><path class="design-cover-front" d="m5 5 11-2v15L5 20V5Z"/><path class="design-cover-line" d="m8 9 5-.9M8 12l5-.9"/></svg>
    </button>
  </div>
</template>

<script>
export default { emits: ['design'] };
</script>

<style scoped>
.gallery-design-entry{display:flex;color:var(--ex-muted,var(--site-text-secondary,#73766b))}
.gallery-design-link{appearance:none;display:inline-flex;align-items:center;gap:8px;min-height:36px;margin:0;padding:4px 0;border:0;border-radius:0;background:transparent;color:inherit;text-align:left;font:400 19px/1.2 'EB Garamond',serif;cursor:var(--site-interactive-cursor,pointer);user-select:none;white-space:nowrap;transition:opacity 140ms ease}
.design-entry-book{display:block;width:23px;height:23px;flex:none;overflow:visible;fill:none;stroke:currentColor;stroke-width:1.1;stroke-linecap:round;stroke-linejoin:round;opacity:.7;transition:opacity 160ms ease,transform 180ms cubic-bezier(.22,1,.36,1)}
.design-cover-back{opacity:.45}
.design-cover-front,.design-cover-line{transition:transform 180ms cubic-bezier(.22,1,.36,1);transform-origin:5px 12px}
.design-cover-line{opacity:.65}
.gallery-design-link:focus-visible{outline:1px solid currentColor;outline-offset:5px}
.gallery-design-link:active{opacity:.65}
@media(hover:hover) and (pointer:fine){.gallery-design-link:hover .design-entry-book{opacity:1;transform:translateX(2px)}.gallery-design-link:hover .design-cover-front,.gallery-design-link:hover .design-cover-line{transform:skewY(-8deg)}}
@media(prefers-reduced-motion:reduce){.gallery-design-link,.design-entry-book,.design-cover-front,.design-cover-line{transition:none;transform:none!important}}
</style>
